import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import state from './orderTypes.state';
import getters from './orderTypes.getters';
import actions from './orderTypes.actions';
import mutations from './orderTypes.mutations';

BaseStore.registerModule('orderTypes', {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('orderTypes');

export {
	mapState,
	mapGetters,
	mapActions,
	mapMutations
};